<template lang="pug">
  include /mixins
  +b.participant-document-view-wrap
    +b.participant-document-view
      +e.content
        +e.preview
          +e.img.IMG(
            :src='preview'
            v-if='!item.err'
          )
          +b.mask-img.LABEL(
            :class="{'mask-img--with-bg': item.err}"
          )
            +e.item.IMG(
              v-if='item.err'
              src='/static/img/error.svg'
            )
        +e.name.P {{ name }}
      +e.close(@click='removeItem(idx)')
        +e.icon.mdi.mdi-close
    +e.error.P(v-if='item.err') {{ item.err }}

</template>
<script>
export default {
  name: 'AddImg',
  props: {
    item: Object,
    idx: Number,
    filekey: { default: 'img' },
    extentions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    preview() {
      if (this.item.img) return this.item.img
      const value = this.item[this.filekey] || this.item.file
      return 'string' === typeof value ? value : ''
    },
    name() {
      return (this.item.file && this.item.file.name) || this.item.title || ''
    },
  },
  methods: {
    removeItem(idx) {
      this.$emit('removeItem', idx)
    },

  },
}
</script>
